<template lang="pug">
  v-card
    v-card-title
      h2.card-title {{ 'base.create_delivery' | translate }}
    v-card-content
      v-select.mb-3(
        :label="$t('base.ingredient')"
        :options="ingredientsList"
        :hint="errorMessage('ingredient')"
        :invalid="!!errorMessage('ingredient')"
        @input="clearError('ingredient')"
        v-model="payload.ingredient")
      .cols-x
        .cols-x__2.mb-3
          v-text-field(
            :focus="true"
            :label="$t('base.price')"
            :hint="errorMessage('price')"
            :invalid="!!errorMessage('price')"  
            @input="clearError('price')"          
            v-model="payload.price")
        .cols-x__2.mb-3
          v-text-field(
            :label="$t('base.weight')"
            :hint="errorMessage('amount')"
            :invalid="!!errorMessage('amount')"  
            @input="clearError('amount')"
            v-model="payload.amount")
      .cols-x
        .cols-x__2.mb-3.remove-margin-above-mobile
          v-select(
            :label="$t('base.type')"
            :options="deliveryTypes"
            v-model="payload.delivery_type")
        .cols-x__2
          v-select(
            :label="companyTypeLabel"
            :options="deliveryCompanies"
            :hint="errorMessage('delivery_company')"
            :invalid="!!errorMessage('delivery_company')"  
            @input="clearError('delivery_company')"
            v-model="payload.delivery_company")
    v-card-actions
      v-btn(
        :loading="loading"
        @click="onCreateDelivery")
        | {{ 'base.add' | translate }}
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import formErrorsMixin from '@/mixins/form-errors.mixin.js'
export default {
  name: 'CreateModal',
  mixins: [formErrorsMixin],
  mounted () {
    const params = {
      is_animalfeed: 'false',
      farm: this.$route.params.farm_id
    }
    this.loadCompanies(params)
    this.loadIngredientsList(params)
  },

  data: () => ({
    payload: {
      ingredient: null,
      price: null,
      amount: null,
      delivery_company: null,
      delivery_type: 'input'
    },
    errors: {
      ingredient: null,
      price: null,
      amount: null,
      delivery_company: null,
    },
    deliveryTypes: [
      { id: 'input', name: 'base.delivery' },
      { id: 'output', name: 'base.sale' }
    ],
    loading: false
  }),

  methods: {
    ...mapActions('deliveries', [
      'loadCompanies',
      'createDelivery'
    ]),

    ...mapActions('ingredients', [
      'loadIngredientsList'
    ]),

    async onCreateDelivery () {
      this.loading = true
      const payload = {
        farm: this.$route.params.farm_id,
        ingredient: { id: this.payload.ingredient },
        amount: this.payload.amount,
        price: this.payload.price,
        delivery_company: { id: this.payload.delivery_company },
        delivery_type: this.payload.delivery_type
      }

      this.checkValidData()

      const { errors } = await this.createDelivery(payload)

      if (!errors) {
        this.$emit('close')
      }
      this.loading = false
    },
    checkValidData () {
      // Clear all errors initially
      this.errors = {
        price: null,
        amount: null,
        delivery_company: null,
        ingredient: null
      }

      // Define validation rules and error codes
      const errorCodes = {
        WRONG_DATA: '1',
        REQUIRED: '4',
        NEGATIVE: '9'
      }

      this.payload.amount = Number(this.payload.amount)
      this.payload.price = Number(this.payload.price)

      // Validate ingredient
      if (!this.payload.ingredient) {
        this.errors.ingredient = [errorCodes.REQUIRED]
      }

      // Validate amount
      if (this.payload.amount < 0) {
        this.errors.amount = [errorCodes.NEGATIVE]
      } else if (isNaN(this.payload.amount)) {
        this.errors.amount = [errorCodes.WRONG_DATA]
      } else if (!this.payload.amount) {
        this.errors.amount = [errorCodes.REQUIRED]
      }

      // Validate price
      if (this.payload.price < 0) {
        this.errors.price = [errorCodes.NEGATIVE]
      } else if (isNaN(this.payload.price)) {
        this.errors.price = [errorCodes.WRONG_DATA]
      } else if (!this.payload.price) {
        this.errors.price = [errorCodes.REQUIRED]
      }

      // Validate delivery_company
      if (!this.payload.delivery_company) {
        this.errors.delivery_company = [errorCodes.REQUIRED]
      }
    }

  },

  computed: {
    ...mapGetters('deliveries', [
      'deliveryCompanies'
    ]),

    ...mapGetters('ingredients', [
      'ingredientsList'
    ]),

    companyTypeLabel () {
      return this.payload.delivery_type === 'input'
        ? 'base.provider'
        : 'base.buyer'
    }
  }
}
</script>
